import { Backdrop, Stack, Typography, Zoom } from "@mui/material";
import Lottie from "lottie-react";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { PLUGIN_NAME } from "config/const";


import loadingMyBee from "../assets/lotti/mybee.json";
import loadingEnergy from "../assets/lotti/Energy.json";
import loadingMeter from "../assets/lotti/meter.json";
import loadingService from "../assets/lotti/service.json";

const ChangeBizLoading = () => {
  const { bt } = useBizTypeTranslation();
  const showLoading = useSelector((state) => state?.sys.changeBizLoading);
  const selectedPlugin = useSelector((state) => state?.userSettings?.selectedPlugin);
  const [lotti, setLotti] = useState(null);
  const [open, setOpen] = useState(false);


  useEffect(() => {
    if (showLoading) {
      if (selectedPlugin === PLUGIN_NAME.SERVICES_CALL) {
        setLotti(loadingService);
      } else if (selectedPlugin === PLUGIN_NAME.MICRO_CONTROLLERS) {
        setLotti(loadingEnergy);
      } else if (selectedPlugin === PLUGIN_NAME.METER_READ) {
        setLotti(loadingMeter);
      } else {
        setLotti(loadingMyBee);
      }
      setOpen(true);
    }
    else {
      setLotti(null);
      setOpen(false);
    }
  }, [showLoading, selectedPlugin]);

  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 500,
        "&.MuiBackdrop-root": {
          bgcolor: "rgba(255, 255, 255, 1)",
          backdropFilter: "blur(2px)",
        },
      }}
      open={open && lotti}
    >
      <Zoom in={open && lotti}>
        <Stack alignItems="center">
          <Stack
            bgcolor="white"
            alignItems="center"
            justifyContent="center"
            borderRadius={100}
            paddingTop={1}
            paddingX={1}
            maxWidth={170}
          >
            <Lottie animationData={lotti} loop={true} />
          </Stack>
          <Typography variant="h5">
            {bt("LOADING_YOUR_WORKSPACE")}
          </Typography>
        </Stack>
      </Zoom>
    </Backdrop>
  );
};
export default ChangeBizLoading;
